import {deleteEmbeddings} from "../db/vectorDb/deleteEmbeddings.ts";

// Helper function to calculate embedding progress
export const calculateEmbeddingProgress = (projectFileBatchIds: any): number => {
    if (!projectFileBatchIds || Object.keys(projectFileBatchIds).length === 0) return 0;
    const totalBatches = Object.keys(projectFileBatchIds).length;
    const completedBatches = Object.values(projectFileBatchIds).filter(status => status === true).length;
    return Math.round((completedBatches / totalBatches) * 100);
};

// Handle embedding updates from websocket
export const handleEmbeddingUpdate = async (
    args: any,
    updateProjectFileBatchIds: any,
    setDynamicStateObj: any,
    dynamicStateObjRef: any,
    userObjRef: any,
    environmentObjRef: any,
    miscMidRenderRefs: any,
    setEnvironmentObj: any
) => {
    if (args.stopped) {
        updateProjectFileBatchIds(null, "clear");
        setDynamicStateObj({
            embeddingInfo: {
                status: null,
                error: null,
                progress: 0
            }
        });
        // Clear the batch queue
        miscMidRenderRefs.current.embeddingBatchQueue = [];
        await deleteEmbeddings(userObjRef.current.user, environmentObjRef.current.projectName);
    } else if (args.batchId) {
        updateProjectFileBatchIds(args.batchId, "delete");

        // Calculate progress based on the updated state
        // Since updateProjectFileBatchIds marks batchId as true when "delete" operation is used
        const currentBatchIds = { ...dynamicStateObjRef.current.projectFileBatchIds };
        currentBatchIds[args.batchId] = true; // Simulate the state update
        const progress = calculateEmbeddingProgress(currentBatchIds);

        setDynamicStateObj({
            embeddingInfo: {
                ...dynamicStateObjRef.current.embeddingInfo,
                progress
            }
        });

        // Auto-close when complete
        if (progress === 100) {
            setTimeout(() => {
                setDynamicStateObj({
                    embeddingInfo: {
                        status: null,
                        error: null,
                        progress: 0
                    }
                });
                miscMidRenderRefs.current.embeddingBatchQueue = [];
                setEnvironmentObj({ projectEmbeddingsLastUpdated: new Date().toISOString() });
            }, 1500);
        }
    }
};

// Handle embedding cancellation when connection is lost
export const handleEmbeddingConnectionLoss = (
    updateProjectFileBatchIds: any,
    setDynamicStateObj: any,
    dynamicStateObjRef: any,
    miscMidRenderRefs: any
) => {
    if (dynamicStateObjRef.current.embeddingInfo.status === 'active') {
        updateProjectFileBatchIds(null, "clear");
        setDynamicStateObj({
            embeddingInfo: {
                status: "error",
                error: "Connection lost. Embedding process was cancelled.",
                progress: 0
            }
        });
        // Clear the batch queue
        miscMidRenderRefs.current.embeddingBatchQueue = [];
    }
};